import React, { useState } from "react";
import { Container } from "../Banner/Banner.styled";
import { func } from "../../../../utils";
import { Button, CountdownTimer } from "../../../atoms";
import { useNavigate } from "react-router-dom";
import { useUserData } from "../../../../store/user";
import moment from "moment";
import WarningBannerFormRegistration from "../../../../pages/v2/FormRegistration/components/WarningBanner/WarningBanner";
import {
  institutionLabelLower,
  isKampusCategory,
} from "../../../../pages/v2/FormRegistration/utils";
import {
  useGetPaymentDetails,
  usePostUpdatePaymentExpired,
} from "../../../../networks";

const imgPath = `${process.env.REACT_APP_API_HOST}/uploads/featured-images/`;
const PAYMENT_REVISION = "payment revision";
const WAITING_PAYMENT = "waiting payment";
const PAYMENT_EXPIRED = "payment expired";

const BannerCityUser = (data = []) => {
  const navigate = useNavigate();
  const {
    mutateAsync: postUpdatePaymentExpired,
    isLoading: loadingUpdatePaymentExpired,
  } = usePostUpdatePaymentExpired();
  const [isExpired, setIsExpired] = useState(false);
  const { registrationData } = useUserData();
  const logo = data?.data?.region_logo;
  const regionName = data?.data?.region_name || "-";
  const location = data?.data?.location || "-";
  const dateLabel = data?.data?.cardDate || "-";
  const dataCompetitionCat = data?.data?.category_name || "Futsal";
  // Label doang yang diubah: "kampus" ditulis "Perguruan Tinggi". Nilai
  // aslinya tetap dipakai buat logika (dataCompetitionCat === "Dance").
  const competitionCatLabel = String(dataCompetitionCat).replace(
    /kampus/gi,
    "Perguruan Tinggi"
  );
  const eventCategoryId = registrationData?.event_category_id;

  const regionId = data?.data?.region_id;
  const userId = data?.data?.id;

  const statusRegistration = isExpired
    ? PAYMENT_EXPIRED
    : !data?.data?.is_notified && data?.data?.registration_revision?.length
    ? String(data?.data?.registration_status)?.toLowerCase()
    : data?.data?.is_notified
    ? String(data?.data?.registration_status)?.toLowerCase()
    : "pending";

  const paymentRevisionNotes = data?.data?.payment_revision;
  const isPaymentRevision = statusRegistration == PAYMENT_REVISION;

  const { data: dataPaymentDetail, isFetching: fetchingDetailPayment } =
    useGetPaymentDetails(
      regionId,

      statusRegistration === PAYMENT_REVISION ||
        statusRegistration === WAITING_PAYMENT ||
        statusRegistration === "selected"
    );

  const expiredPayment = dataPaymentDetail?.data?.data?.expired_at?.toString();
  const schoolCategory = String(
    registrationData?.school_category
  )?.toLowerCase();
  // "sekolah" buat SMP/SMA, "perguruan tinggi" buat KAMPUS.
  const institution = institutionLabelLower(schoolCategory);
  // Peserta kampus mendaftar sebagai tim, bukan mewakili satu sekolah, jadi
  // sebutannya "Tim kamu" — bukan "Perguruan tinggi kamu".
  const selectedSubject = isKampusCategory(schoolCategory)
    ? "Tim kamu"
    : "Sekolah kamu";
  const dateCat =
    dataCompetitionCat === "Dance"
      ? data?.data?.dance_registration_announcement_date
      : data?.data?.registration_announcement_date;
  const announcementDate = moment(dateCat)?.isValid()
    ? moment(dateCat)?.format("DD MMMM YYYY")
    : "-";
  console.log({ data: data });
  const currentDate = moment()?.format("YYYY-MM-DD HH:mm:ss");
  const eventStartDate = moment(data?.data?.event_start_date)?.format(
    "YYYY-MM-DD HH:mm:ss"
  );

  const NOW_IN_MS = new Date(expiredPayment)?.getTime();

  const expiredDateCountdown = NOW_IN_MS;
  const expiredDateLabel = moment(expiredPayment).format("D MMMM YYYY");

  const dataCompleted = data?.data?.is_filled_team_list;
  const handleExpiredPayment = () => {
    setIsExpired(true);
    postUpdatePaymentExpired({ registrationId: userId });
  };
  const getDataAttr = () => {
    switch (statusRegistration) {
      case "pending":
        return {
          title: "Pendaftaran kamu masih dalam proses seleksi pihak panitia",
          subtitle: `Pengumuman paling lambat pada tanggal ${announcementDate} di Instagram dan Web`,
          btnLabel: "Follow Social Media Piala by.U",
          btnAction: () =>
            window.open("https://www.instagram.com/pialabyu/", "_blank"),
          swooshImg: "swoosh-regist-pending.png",
          bgColor: "#daf7ff4d",
          borderColor: "#DAF7FF",
        };
      case "approved":
        return {
          title: `Selamat! ${selectedSubject} terpilih mengikuti Piala by.U ${regionName}!`,
          subtitle: dataCompleted
            ? "Selamat bertanding dan menjadi Juaranya Piala by.U"
            : `Pengumuman paling lambat pada tanggal ${announcementDate} di Instagram dan Web`,
          btnLabel: dataCompleted
            ? false
            : // ? "Lihat Jadwal Pertandingan"
              "Lengkapi Data Pemain",
          btnAction: () =>
            dataCompleted
              ? navigate(`/${regionName}/jadwal-pertandingan`)
              : navigate(
                  `${regionName}/registrasi/add-player/${schoolCategory}/${userId}`
                ),

          swooshImg: "swoosh-regist-approved.png",
          bgColor: "#53c3681a",
          borderColor: "#C6EBCD",
        };
      case "not approved":
        return {
          title: `Maaf ya, ${institution} kamu belum lolos seleksi Piala by.U`,
          subtitle: `Tetap semangat dan coba lagi tahun depan yaa`,
          btnLabel: "Follow Social Media Piala by.U",
          btnAction: () =>
            window.open("https://www.instagram.com/pialabyu/", "_blank"),
          swooshImg: "swoosh-regist-not-approved.png",
          bgColor: "#af183c1a",
          borderColor: "#EAC2CC",
        };
      case "need revision":
        return {
          title: "Data kamu butuh revisi",
          subtitle: "Harap lihat catatan perbaikan di halaman form pendaftaran",
          btnLabel: "Ubah Data Pendaftaran",
          btnAction: () => {
            /** Dance Category ID */
            if (eventCategoryId === 3) {
              return navigate(
                `/${regionName}/registrasi/form-dance/${schoolCategory}/${regionId}/${eventCategoryId}/edit`
              );
            }
            navigate(
              `/${regionName}/registrasi/form/${schoolCategory}/${regionId}/${eventCategoryId}/edit`
            );
          },
          swooshImg: "swoosh-regist-revision.png",
          bgColor: "#f8cf5a1a",
          borderColor: "#FCEAB6",
        };
      case "waiting list":
        return {
          title: "Tim Kamu Berada di Waiting List",
          subtitle:
            "Tim kamu sekarang masih dalam waiting list, silahkan tunggu selama 3 hari kedepan untuk informasi selanjutnya",
          btnLabel: false,

          swooshImg: "swoosh-regist-revision.png",
          bgColor: "#f8cf5a1a",
          borderColor: "#FCEAB6",
        };
      case WAITING_PAYMENT:
      case "selected":
        return {
          title: `Selamat! ${selectedSubject} terpilih mengikuti Piala by.U ${regionName}!`,
          subtitle: () => (
            <span>
              {`Segera lakukan pembayaran sebelum`} <b> {expiredDateLabel}</b>{" "}
              {`untuk melanjutkan perjalananmu di Piala by.U ${regionName}`}
            </span>
          ),
          subtitle2: () => (
            <div>
              <span className="font-bold md:text-[14px] text-[12px]">
                {"Batas Waktu Pembayaran"}
              </span>
              {!fetchingDetailPayment && (
                <div className="flex justify-center md:mb-0 mb-6">
                  <CountdownTimer
                    targetDate={expiredDateCountdown}
                    isTextInsideBox
                    expiredAction={handleExpiredPayment}
                  />
                </div>
              )}
            </div>
          ),
          btnLabel: "Lakukan Pembayaran",
          btnAction: () => navigate(`/pembayaran`),
          swooshImg: "swoosh-regist-revision.png",
          bgColor: "#f8cf5a1a",
          borderColor: "#FCEAB6",
        };
      case "waiting payment confirmation":
      case "payment submitted":
        return {
          title: "Pembayaran Sedang Dikonfirmasi",
          subtitle:
            "Terima kasih! Pembayaran Anda sedang dalam proses konfirmasi.",
          btnLabel: false,
          swooshImg: "swoosh-regist-revision.png",
          bgColor: "#f8cf5a1a",
          borderColor: "#FCEAB6",
        };
      case "data complete": {
        return {
          title: "Pendaftaran Sukses!",
          subtitle:
            "Data telah lengkap, dan timmu siap untuk berlaga di arena. Saatnya menunjukkan kemampuan terbaik!",
          //   btnLabel: "Lihat Jadwal Pertandingan",
          btnLabel: false,
          btnAction: () => navigate(`/${regionName}/jadwal-pertandingan`),

          swooshImg: "swoosh-regist-approved.png",
          bgColor: "#53c3681a",
          borderColor: "#C6EBCD",
        };
      }
      case "payment success":
      case "payment approved":
        return {
          title: "Pembayaran Terkonfirmasi! Kamu Sudah Terdaftar di Piala by.U",
          subtitle: `Selamat, kamu resmi terdaftar sebagai peserta Piala by.U ${regionName}. Siapkan dirimu untuk tantangan seru yang menanti!`,
          btnLabel:
            dataCompetitionCat === "Dance"
              ? "Lihat Jadwal Pemain"
              : "Lengkapi Data Pemain",

          btnAction: () =>
            dataCompetitionCat === "Dance"
              ? navigate(`/${regionName}/jadwal-pertandingan`)
              : navigate(
                  `${regionName}/registrasi/add-player/${schoolCategory}/${userId}`
                ),

          swooshImg: "swoosh-regist-approved.png",
          bgColor: "#53c3681a",
          borderColor: "#C6EBCD",
        };
      case "payment failed":
      case PAYMENT_REVISION:
        return {
          title: `Maaf ya, Pembayaran Kamu Tidak Disetujui`,
          subtitle: () => (
            <span className="md:w-[auto] w-[343px] inline-block md:inline">
              {`Mohon untuk mengupload ulang bukti pembayaran yang valid agar proses dapat dilanjutkan sebelum`}
              <b> {expiredDateLabel}</b>
              {"."}
            </span>
          ),
          subtitle2: () => (
            <div>
              <span className="font-bold md:text-[14px] text-[12px]">
                {"Batas Waktu Pembayaran"}
              </span>
              {!fetchingDetailPayment && (
                <div className="flex justify-center md:mb-0 mb-6">
                  <CountdownTimer
                    targetDate={expiredDateCountdown}
                    isTextInsideBox
                    expiredAction={handleExpiredPayment}
                  />
                </div>
              )}
            </div>
          ),
          btnLabel: "Lakukan Pembayaran",
          btnAction: () => navigate(`/pembayaran`),
          swooshImg: "swoosh-regist-revision.png",
          bgColor: "#f8cf5a1a",
          borderColor: "#FCEAB6",
        };
      case "payment expired":
        return {
          title: `Oops, Waktu Pembayaran Sudah Habis!`,
          subtitle: `Sayang banget, batas waktu pembayaran sudah lewat, jadi tim kamu nggak bisa ikut Piala byU kali ini. Tapi jangan khawatir, masih banyak kesempatan lain! Sampai jumpa di event berikutnya ya. Terima kasih!`,
          btnLabel: "Follow Social Media Piala by.U",
          btnAction: () =>
            window.open("https://www.instagram.com/pialabyu/", "_blank"),
          swooshImg: "swoosh-regist-not-approved.png",
          bgColor: "#af183c1a",
          borderColor: "#EAC2CC",
        };
      default:
        return {
          title: `-`,
          subtitle: `-`,
          btnLabel: "-",
          btnAction: () => null,
          swooshImg: null,
        };
    }
  };

  const {
    title,
    subtitle,
    btnLabel,
    btnAction,
    swooshImg,
    borderColor,
    bgColor,
    subtitle2 = () => null,
  } = getDataAttr();
  const handleClick = () => btnAction();

  // Add a helper function to preserve registration parameters
  const preserveRegistrationParams = (path) => {
    // Get the current school category from localStorage
    const schoolCategoryData =
      JSON.parse(localStorage.getItem("school-category-data")) || {};
    const currentSchoolCategory = schoolCategoryData.state?.schoolCategory;

    // Only add the state if a schoolCategory exists
    return {
      pathname: path,
      state: currentSchoolCategory
        ? {
            category: currentSchoolCategory,
            preserveCategory: true, // Flag to indicate we should preserve this value
          }
        : undefined,
    };
  };

  if (data?.data?.region_name) {
    return (
      <>
        {isPaymentRevision && (
          <div className="md:mt-16 mt-[64px]">
            <WarningBannerFormRegistration
              title="Maaf Pembayaran Tidak Valid"
              freeTextSubtitle={paymentRevisionNotes}
            />
          </div>
        )}

        <div className="md:rounded-xl w-[100vw] md:w-full">
          <Container justifyContent={"center"} display={"flex"}>
            <div
              className={`mx-auto rounded-xl overflow-hidden w-[100vw] md:w-full  z-10 flex md:pb-4 ${
                !isPaymentRevision
                  ? "mt-[64px] lg:mt-[41px] lg:!ml-auto !ml-0"
                  : "md:mt-6 mt-[0px]"
              }`}
              style={{
                backgroundImage: `url(${func.getStaticImg(
                  `/illustration/${swooshImg}`
                )})`,
                backgroundRepeat: "no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "top right",
                border: `1px solid ${borderColor}`,
                backgroundColor: bgColor,
              }}
            >
              <div className="md:w-full w-min md:flex md:pr-8">
                <div className="flex flex-col  md:justify-center md:w-full md:pr-4">
                  <div className="bg-[#1F2D3D] text-white font-bold text-[13px] px-4 py-2 rounded-b-lg inline-block ml-6 mt-0 w-max">
                    {competitionCatLabel} Competition
                  </div>
                  <div className="md:w-full md:pr-4">
                    <div className="m-[16px] px-[16px] md:p-3 bg-white flex items-center justify-between text-[14px] rounded-2xl md:w-full h-[76px] md:h-auto">
                      <div>
                        <div className="md:text-[16px] text-[14px] font-semibold">
                          {regionName}, {dateLabel}
                        </div>
                        <span className="flex items-center mt-1 leading-tight text-[12px] text-[#6A7481] md:text-[14px]">
                          <img
                            src={func.getStaticImg(
                              "/illustration/pin-blue.svg"
                            )}
                          />
                          {location}
                        </span>
                      </div>

                      <div className="md:flex-shrink-0">
                        <img
                          className="object-cover h-[52px] w-[66px]"
                          src={`${imgPath}/${logo}`}
                          alt="School Logo"
                          onClick={() => navigate("/")}
                        />
                      </div>
                    </div>
                    <div className="text-center w-[100vw] md:w-full md:px-4">
                      <p className="mt-2 text-gray-500 mx-auto text-[12px] md:text-[13px]">
                        Status Pendaftaran:
                      </p>
                      <p className="mt-2 text-gray-700 font-bold text-[20px] md:text-[24px]">
                        {title}
                      </p>
                      <p className="mt-2 text-gray-500 text-[13px] mb-4 md:text-[14px]">
                        {typeof subtitle === "function"
                          ? subtitle?.()
                          : subtitle}
                      </p>
                      {subtitle2?.()}
                      {btnLabel ? (
                        <Button
                          className={
                            "w-[327px] h-[44px] mb-4 text-[16px] p-0 md:mt-2"
                          }
                          onClick={handleClick}
                        >
                          {btnLabel}
                        </Button>
                      ) : (
                        <></>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* <img
          src={func.getStaticImg("/illustration/swoosh-regist-success.png")}
          className="col-start-1 row-start-1 self-center opacity-25"
        /> */}
          </Container>
        </div>
      </>
    );
  }
};

export default BannerCityUser;
